// @ts-nocheck
/*
 * @Author: changcheng
 * @LastEditTime: 2024-12-02 10:40:59
 */
import { useState } from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import {
  // Home,
  Index,
  CourseTrain,
  Play,
  EmergencyCourse,
  Portal,
  NewsList,
  NewsDetails,
  CoreCourse,
  SubjectCourse,
  MeetingActivite,
  MeetingActiviteByGx,
  Live20231010am,
  Live20231010pm,
  PressConference,
  GuideCenter,
  Login,
  Register,
  IframeComponent,
  LivePlatform,
  MeetingActiveByHn,
  MeetingActiviteBySc,
  MeetingActiviteByGz,
  MeetingActiviteByHb,
  CompreImprovement
} from "@root/pages/index";
import { RouterAuthorizan } from "@root/components/router/router";
import { routerAuthorizonMap } from "@root/common/routerMap";
import Footer from "@root/components/footer/index";
import { store } from "@root/store/index";
import { Spin, ConfigProvider } from "antd";
import zhCN from "antd/es/locale/zh_CN";
const routes = [
  {
    path: "/home",
    element: <Index />,
    children: [
      {
        path: "index",
        element: <Portal />,
      },
      {
        path: "COVID-19",
        element: <EmergencyCourse />,
      },
      {
        path: "livePlatform",
        element: <LivePlatform />,
      },
      {
        path: "meetingActivite",
        element: <MeetingActivite />,
      },
      {
        path: "MeetingActiviteByGz",
        element: <MeetingActiviteByGz />,
      },
      {
        path: "meetingActiviteByGx",
        element: <MeetingActiviteByGx />,
      },
      {
        path: "meetingActiviteByHn",
        element: <MeetingActiveByHn />,
      },
      {
        path: "meetingActiviteBySc",
        element: <MeetingActiviteBySc />,
      },
      {
        path: "MeetingActiviteByHb",
        element: <MeetingActiviteByHb />,
      },
      {
        path: "pressConference",
        element: <PressConference />,
      },
      {
        path: "compreImprovement",
        element: <CompreImprovement />,
      },
      {
        path: "courseTrain",
        element: <CourseTrain />,
        children: [
          {
            path: "coreCourse",
            element: <CoreCourse />,
          },
          {
            path: "subjectCourse",
            element: <SubjectCourse />,
          },
        ],
      },
      {
        path: "userCenter",
        element: <RouterAuthorizan />,
        children: [],
      },
    ],
  },
  {
    path: "/news",
    element: <Index />,
    children: [
      {
        path: "list/:listId",
        element: <NewsList />,
      },
      {
        path: "details/:detailId",
        element: <NewsDetails />,
      },
    ],
  },
  {
    path: "/play",
    element: <Play />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },

  {
    path: "/live20231010am",
    element: <Live20231010am />,
  },
  {
    path: "/live20231010pm",
    element: <Live20231010pm />,
  },
  {
    path: "/guideCenter",
    element: <GuideCenter />,
  },
  {
    path: "/iframeComponent",
    element: <IframeComponent />,
  },
];

// 动态添加(userCenter)子路由
// const { children } = routes[0].children[2];
const { children } = routes[0].children?.find((v) => v.path === "userCenter");
for (let [path, item] of routerAuthorizonMap.entries()) {
  children.push({
    path,
    element: item,
  });
}

/**
 * 递归子路由
 * @param children
 * @returns
 */
function deepChildren(children) {
  return children.map((current, idxs) => (
    <Route path={current.path} element={current.element} key={idxs}>
      {current.children && deepChildren(current.children)}
    </Route>
  ));
}
/**
 * 递归一级路由
 * @param routes
 * @returns
 */
function deepRouterComponent(routes) {
  return routes.map((item, idx) => (
    <>
      <Route path={item.path} element={item.element} key={idx}>
        {item.children && deepChildren(item.children)}
      </Route>
    </>
  ));
}
export default function App() {
  const [loading, setLoading] = useState(store.getState().globalInfo.loading);
  store.subscribe(() => {
    let storeState = store.getState();
    setLoading(storeState.globalInfo.loading);
  });

  return (
    <ConfigProvider locale={zhCN}>
      <Spin spinning={typeof loading === "number" ? false : loading}>
        <HashRouter>
          <Routes>{deepRouterComponent(routes)}</Routes>
          <Footer />
        </HashRouter>
      </Spin>
    </ConfigProvider>
  );
}
